import { EngagementMeeting } from '../models/get-engagement-conference';

export interface HeldMeetingsOfABreak {
    breakStartUtc: string;
    meetings: EngagementMeeting[];
}

export interface HeldMeetingsByBreak {
    afterTheLatestBreak: EngagementMeeting[];
    byBreak: HeldMeetingsOfABreak[];
}

// [#1305] Held meetings grouped by the break they came before (heldBeforeBreakUtc from the API), the latest break first,
// each meeting in one group only. The ones held after the latest break carry no break and stay in the list as before.
export const groupHeldMeetingsByBreak = (meetings: EngagementMeeting[]): HeldMeetingsByBreak => {
    const breakStarts = Array.from(new Set(meetings.map((meeting) => meeting.heldBeforeBreakUtc).filter(Boolean)));
    return {
        afterTheLatestBreak: meetings.filter((meeting) => !meeting.heldBeforeBreakUtc),
        byBreak: breakStarts
            .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
            .map((breakStartUtc) => ({
                breakStartUtc,
                meetings: meetings.filter((meeting) => meeting.heldBeforeBreakUtc === breakStartUtc),
            })),
    };
};
